import React, {PureComponent } from "react";


import {  IViewProps, View } from "core/decorators/View";
import InputConfig from "./InputConfig";
import { Classes } from "@blueprintjs/core";
import { iDef } from "core/util/TypeUtils";

export enum InputVariant {
	TEXT = "text",
	PASSWORD = "password",
}

export interface IStyledInpuProps extends IViewProps<InputConfig, InputVariant> {
	isActive?: boolean;
	loading?: boolean;
	onChange?: (e: any) => void;
	href?: string;
	disabled?: boolean;
	button?: boolean;
	span?: boolean;
	attrs?: any;
	style?:any;
	name:string;
	placeholder?:string;
	value?:string;
}




@View({ id: "input", configClass: InputConfig, variants: InputVariant })
export class InputView extends PureComponent<IStyledInpuProps> {

	setBpProps(){
		const inputProps= this.props.config.inputGroupState;
		let classNames = [Classes.INPUT];
		if(inputProps){ 
			inputProps.disabled && classNames.push(" ",Classes.DISABLED);
			inputProps.fill && classNames.push(" ",Classes.FILL);
			inputProps.large && classNames.push(" ",Classes.LARGE);
			inputProps.small && classNames.push(" ",Classes.SMALL);
			inputProps.round && classNames.push(" ",Classes.ROUND);	
		}
		return classNames.join(" ");
	}
	
	render(){
		const {config, onChange, style, name, value, disabled}= this.props;

		let val = "";
		if (iDef(value)){
			val=value;
		}

		const inputProps= config.inputGroupState;
		
		return(
			<React.Fragment>
				<input className={this.setBpProps()} value={val} disabled={disabled}  name= {name} type= {inputProps.type} onChange={onChange} style= {style} placeholder= {this.props.placeholder}/>
			</React.Fragment>
		);
	}

}




// WEBPACK FOOTER //
// ./src/common/views/input/Input.view.tsx